import {
  Alert,
  Button,
  CardHeader,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AutocompleteCombobox, {
  adaptDataValueToAutocompleteData,
} from "../shared/AutocompleteCombobox";
import {
  evaluation_refonte_category_service,
  evaluation_refonte_fiche_evaluation_service,
  evaluation_refonte_questionnaire_par_fiche_service,
  evaluation_refonte_questionnaire_service,
} from "../../../services/PersonalEvaluationRefonteService";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../../components/reusable/NotificationBull";
import { RefreshOutlined } from "@material-ui/icons";
import StandardSkeletoon from "../../../components/reusable/loader/StandardSkeletoon";

const AssignerCritereToFiche = ({ isOpen, current_fiche, handle_close }) => {
  const { Toast, showToast } = useToast();

  const [categories, setCategories] = useState([]);
  const [fiches, setFiches] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [motCle, setMotCle] = useState("");
  const [formLoad, setFormLoad] = useState(false);
  const [filtre, setFiltre] = useState({
    QUESTION: "",
    CATEGORY: {},
    FICHE: current_fiche,
  });

  const handleLoadAllQuesitons = () => {
    setFormLoad(true);
    evaluation_refonte_questionnaire_service
      .getListByFiche(filtre)
      .then((res) => {
        if (res) {
          setQuestions(res.data || []);
        }
      })
      .finally(() => {
        setFormLoad(false);
      });
  };

  const handleLoadAllData = () => {
    evaluation_refonte_fiche_evaluation_service
      .getList({ mot_cle: "" })
      .then((res) => {
        if (res) {
          setFiches(res.data || []);
        }
      });
    evaluation_refonte_category_service.getList({ mot_cle: "" }).then((res) => {
      if (res) {
        setCategories(res.data || []);
      }
    });
    handleLoadAllQuesitons();
  };

  const handleCloseDialog = () => {
    setFiltre([]);
    handle_close();
  };

  const handleChangeCategoryCritere = (new_val) => {
    setFiltre({ ...filtre, CATEGORY: new_val });
  };

  const handleChangeFiche = (new_val) => {
    setFiltre({ ...filtre, FICHE: new_val });
  };

  const handleAssignQuestion = (evt, item) => {
    const val = evt.target.checked;
    let copy_question = questions.slice();
    let current_index = copy_question.indexOf(item);
    let curr_item = copy_question[current_index];
    curr_item.ID_FICHE_EVALUATION = val
      ? filtre.FICHE.ID_FICHE_EVALUATION
      : null;
    setQuestions(copy_question);
  };

  const handleSaveAssignedQuestionToFiche = () => {
    evaluation_refonte_questionnaire_par_fiche_service
      .insert_or_delete(filtre.FICHE.ID_FICHE_EVALUATION, questions)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleCloseDialog();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      });
  };

  useEffect(() => {
    if (current_fiche) {
      setFiltre((prevFiltre) => ({ ...prevFiltre, FICHE: current_fiche }));
    }
  }, [current_fiche,isOpen]);

  useEffect(() => {
    if (filtre || isOpen) {
      handleLoadAllQuesitons();
    }
    if (isOpen) {
      handleLoadAllData();
    }
  }, [isOpen, filtre]);

  return (
    <>
      <Toast />
      <Dialog
        open={isOpen}
        /* onClose={ handleDialogClose} */
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <Paper>
          <Grid>
            <DialogTitle>Assigner questionnaire existant</DialogTitle>
            <DialogContent>
              <Grid>
                <Typography className="form-control">Fiche *</Typography>
                <AutocompleteCombobox
                  onChange={handleChangeFiche}
                  label={"Fiche *"}
                  limitTags={2}
                  fullWidth
                  data={adaptDataValueToAutocompleteData(
                    fiches,
                    "LIBELE_FICHE",
                    "ID_FICHE_EVALUATION"
                  )}
                  valeur={adaptDataValueToAutocompleteData(
                    fiches,
                    "LIBELE_FICHE",
                    "ID_FICHE_EVALUATION"
                  ).find(
                    (item) =>
                      item.ID_FICHE_EVALUATION ===
                      filtre.FICHE?.ID_FICHE_EVALUATION
                  )}
                />
                <Typography className="form-control">
                  Catégorie critere
                </Typography>
                <AutocompleteCombobox
                  limitTags={2}
                  fullWidth
                  label="Catégorie critere"
                  data={adaptDataValueToAutocompleteData(
                    categories,
                    "CATEGORY_NAME",
                    "ID_CATEGORY"
                  )}
                  onChange={handleChangeCategoryCritere}
                />
              </Grid>
              <Grid mt={1.5}>
                <Divider variant="fullWidth" />
                <Grid
                  flexGrow={1}
                  mb={1}
                  display={"flex"}
                  flexDirection={"row"}
                >
                  <Grid flexGrow={1}>
                    <CardHeader
                      title={"Liste des questions"}
                      sx={{ mb: -1 }}
                      titleTypographyProps={{
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    />
                  </Grid>
                  <Grid display={"flex"} alignItems={"end"}>
                    <TextField
                      size="small"
                      placeholder="Recherche"
                      onChange={(e) => setMotCle(e.target.value)}
                    />
                    <Button onClick={(e) => handleLoadAllData()}>
                      <RefreshOutlined />
                    </Button>
                  </Grid>
                </Grid>
                <Divider variant="fullWidth" />
                <Grid
                  maxHeight={"25vh"}
                  overflow={"auto"}
                  display={formLoad ? "" : "none"}
                  width={"100%"}
                >
                  <StandardSkeletoon row={5} m={2} show={formLoad} />
                </Grid>
                <Grid
                  maxHeight={"25vh"}
                  minHeight={"20vh"}
                  display={!formLoad ? "" : "none"}
                  overflow={"auto"}
                  width={"100%"}
                >
                  {questions
                    .filter((item) => String(item.QUESTION).includes(motCle))
                    .map((item, idx) => (
                      <Paper elevation={1} sx={{ m: 0.5 }} key={idx}>
                        <Grid
                          p={1.5}
                          m={0.5}
                          display={"flex"}
                          flexDirection={"row"}
                        >
                          <Grid display={"flex"} flexGrow={1}>
                            <CardHeader
                              title={item.QUESTION}
                              titleTypographyProps={{ variant: "body1" }}
                              subheader={`Type:${item.TYPE_NAME} / crée le ${
                                item.CREATION_DATE_TYPE || ""
                              }`}
                              subheaderTypographyProps={{ variant: "caption" }}
                            />
                          </Grid>
                          <Grid display={"flex"} alignContent={"center"}>
                            <Checkbox
                              disabled={!filtre.FICHE}
                              checked={item.ID_FICHE_EVALUATION ? true : false}
                              onChange={(e) => handleAssignQuestion(e, item)}
                            />
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                </Grid>
              </Grid>
            </DialogContent>
            <Divider variant="middle" />
            <DialogActions>
              <Button
                disabled={!filtre.FICHE}
                variant="contained"
                color="primary"
                onClick={(e) => handleSaveAssignedQuestionToFiche()}
              >
                Enregistrer
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCloseDialog}
              >
                Fermer
              </Button>
            </DialogActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default AssignerCritereToFiche;
